module.exports = __webpack_public_path__ + "Roboto-MediumItalic.da059a7386fea889c55c.woff";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-MediumItalic.woff
// module id = 147
// module chunks = 10